import React from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import { StyledFormGroup, Feedback, COLLEGE_TYPES } from './Common';
import LocationFields from './LocationFields';
import InstitutionField from './InstitutionField';

const UGForm = ({
    register,
    sectionErrors,
    detailsPath,
    states,
    districts,
    institutions,
    setValue,
    onInstitutionAdded,
    selectedState,
    selectedDistrict,
    level
}) => {
    return (
        <>
            <LocationFields
                register={register}
                detailsPath={detailsPath}
                sectionErrors={sectionErrors}
                states={states}
                districts={districts}
                selectedState={selectedState}
            />

            <Row>
                <StyledFormGroup as={Col} md="4">
                    <Form.Label>Year <span className="text-danger">*</span></Form.Label>
                    <Form.Select {...register(`${detailsPath}.year`)} isInvalid={!!sectionErrors.year}>
                        <option value="">Select Year</option>
                        {[1, 2, 3, 4].map(y => (
                            <option key={y} value={y}>
                                {y}{y === 1 ? "st" : y === 2 ? "nd" : y === 3 ? "rd" : "th"} Year
                            </option>
                        ))}
                    </Form.Select>
                    <Feedback error={sectionErrors.year} />
                </StyledFormGroup>

                <InstitutionField
                    label="Organization Name"
                    fieldName="collegeName"
                    register={register}
                    setValue={setValue}
                    sectionErrors={sectionErrors}
                    detailsPath={detailsPath}
                    institutions={institutions}
                    onInstitutionAdded={onInstitutionAdded}
                    selectedState={selectedState}
                    selectedDistrict={selectedDistrict}
                    level={level}
                />

                <StyledFormGroup as={Col} md="4">
                    <Form.Label>Place <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Enter Place"
                        {...register(`${detailsPath}.place`)}
                        isInvalid={!!sectionErrors.place}
                    />
                    <Feedback error={sectionErrors.place} />
                </StyledFormGroup>
            </Row>

            <Row>
                <StyledFormGroup as={Col} md="4">
                    <Form.Label>Affiliated University</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Enter Affiliated University"
                        {...register(`${detailsPath}.affiliatedUniversity`)}
                        isInvalid={!!sectionErrors.affiliatedUniversity}
                    />
                    <Feedback error={sectionErrors.affiliatedUniversity} />
                </StyledFormGroup>

                <StyledFormGroup as={Col} md="4">
                    <Form.Label>Program / Department </Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Enter Program / Department"
                        {...register(`${detailsPath}.programDepartment`)}
                        isInvalid={!!sectionErrors.programDepartment}
                    />
                    <Feedback error={sectionErrors.programDepartment} />
                </StyledFormGroup>

                <StyledFormGroup as={Col} md="4">
                    <Form.Label>Organization Type <span className="text-danger">*</span></Form.Label>
                    <Form.Select
                        {...register(`${detailsPath}.collegeType`)}
                        isInvalid={!!sectionErrors.collegeType}
                    >
                        <option value="">Select</option>
                        {COLLEGE_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
                    </Form.Select>
                    <Feedback error={sectionErrors.collegeType} />
                </StyledFormGroup>
            </Row>
        </>
    );
};

export default UGForm;
